// daterangepicker resolves moment via `window.moment` when it is present and
// only falls back to its bundled copy otherwise. Under Vite's CJS interop that
// fallback resolves to `{ default: fn }` rather than the callable function,
// which makes every internal `moment()` call throw "moment is not a function".
//
// Exposing the real moment function on `window` before daterangepicker is
// imported makes it take the working branch. This module must be imported
// ahead of 'daterangepicker' so the global is set during evaluation.
import momentImport from 'moment';

const moment = typeof momentImport === 'function' ? momentImport : momentImport.default;

window.moment = moment;

export default moment;
